export default "__VITE_ASSET__89a4fd67__"